module.exports = __webpack_public_path__ + "img/general-bg-1.29ae5f3f.svg";